import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import config from "../../config";
import { Link } from "react-router-dom";
import Account from "../../components/Account";
import {
	getAccounts,
	logout
} from "../../modules/user";
const Loader = require("react-loaders").Loader;
const StartHelp = (props) => <div div className={"header"} style={{textAlign: "center"}}>
	<div style={{fontSize: "18pt"}}>Start by syncing your accounts</div>
</div>;
class Home extends React.Component {
	constructor(props) {
		super(props);
		this.state = {loading: true};
	}
	componentWillMount() {
		this.props.getAccounts()
			.then(() => {
				this.setState({loading: false});
			});
	}
	render() {
		if (this.props.user.username) {
			return <div>
				<header>
					<div className={"header"}>
						<img src="//fileslogin.edialog24.com/images/logo-white.png" alt="eDialog24 logo" className="header-logo"/>
						<div className={"top-menu"}><Link to="#" onClick={() => this.props.logout()}>Log out <i class="fa fa-sign-out"></i></Link></div>
					</div>
				</header>
				<div>
					<div id={"welcome"}>
						<h2>My Accounts ({this.props.user.username})</h2>
						<div id={"api"}><br/>Sync your accounts below and then subscribe to the accounts you want handled by eDialog24. We need you to send us the API-key and Account info to each of the accounts you subscribe to.
							<br/><br/><strong>API-key:</strong> {btoa(this.props.user.username + ":" + this.props.user.password)}
						</div>

						<div className={"row"}>
							<div className={"col-sm-6"}>
								<div className={"custombutton"}>
									<a style={{display: "block", height: "100%"}} href={`${config.host}/login/facebook`}>
                                        Sync accounts from Facebook <i className="fa fa-facebook"/>
									</a>
								</div>
							</div>
							<div className={"col-sm-6"}>
								<div className={"custombutton"}>
									<a style={{display: "block", height: "100%"}} href={`${config.host}/login/twitter`}>
                                        Sync accounts from Twitter <i className="fa fa-twitter"/>
									</a>
								</div>
							</div>
						</div>

					</div>
					<div id={"accounts"}>
						{
							this.state.loading ? <Loader type="line-scale" active color="#ccc" /> :
								this.props.accounts.length > 0 ? this.props.accounts.map((acc, i) => <Account key={i} account={acc} {...this.props}/>) : <StartHelp {...this.props}/>
						}
					</div>
				</div>
			</div>;
		}
		else {
			return <div><Loader type="line-scale" active color="#ccc" /></div>;
		}
	}
}

const mapStateToProps = ({ user, session, accounts }) => ({
	user,
	accounts,
	authenticated: session.authenticated,
	sessionReady: session.ready
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
	getAccounts,
	logout
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/index.js